import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const WatermarkBackground = () => {
  const location = useLocation();
  const isVendorSpace = location.pathname.startsWith('/space/');
  const isFloorTax = location.pathname.startsWith('/floor-tax');
  const isSafeSpace = location.pathname.startsWith('/safe-space');
  const overlayRef = useRef(null);

  useEffect(() => {
    if (isVendorSpace || isFloorTax || isSafeSpace) {
      if (overlayRef.current) overlayRef.current.style.display = 'none';
      return;
    }

    let el = overlayRef.current;
    if (!el) {
      el = document.createElement('div');
      el.id = 'watermark-bg-overlay';
      el.style.cssText = 'position:fixed;inset:0;z-index:0;pointer-events:none;transition:opacity 0.3s ease;';
      document.querySelector('.App')?.prepend(el);
      overlayRef.current = el;
    }
    el.style.display = '';

    const applyBackground = () => {
      const isMobile = window.innerWidth < 768;
      if (isMobile) {
        el.style.backgroundImage = 'url(/backgrounds/watermark-graffiti-2.webp), url(/backgrounds/watermark-graffiti-1-flipped.webp)';
        el.style.backgroundSize = '140%, 200%';
        el.style.backgroundPosition = 'bottom left, top right';
      } else {
        el.style.backgroundImage = 'url(/backgrounds/watermark-graffiti-1.webp), url(/backgrounds/watermark-graffiti-2-flipped.webp)';
        el.style.backgroundSize = 'cover, cover';
        el.style.backgroundPosition = 'center, center';
      }
      el.style.backgroundRepeat = 'no-repeat, no-repeat';
      el.style.backgroundAttachment = 'fixed, fixed';
    };

    const applyOpacity = () => {
      const isLight = document.body.classList.contains('light');
      el.style.opacity = isLight ? '0.18' : '1';
    };

    applyBackground();
    applyOpacity();

    window.addEventListener('resize', applyBackground);
    const observer = new MutationObserver(applyOpacity);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => {
      window.removeEventListener('resize', applyBackground);
      observer.disconnect();
    };
  }, [isVendorSpace, isFloorTax, isSafeSpace]);

  return null;
};

export default WatermarkBackground;
